export default "__VITE_ASSET__B9jOzx0R__"